import React from 'react';
import styled from 'styled-components';
import country from './country.json';

const Dropdown = styled.select`
  font-size: 14px;
  width: 100%;
  height: 40px;
  color: ${(props) => (props.darkTheme && props.isFromModal ? props.theme.txtPrimary : props.darkTheme ? props.theme.inputsColor : 'var(--inputTxtColor)')};
  background: ${(props) =>
    props.disabled && props.darkTheme
      ? props.theme.selectionBg
      : props.disabled && !props.darkTheme
      ? 'var(--light)'
      : props.darkTheme && props.isFromModal
      ? 'var(--dark)'
      : props.darkTheme
      ? props.theme.cardBg
      : '#fff'};
  border: 1px solid ${(props) => (props.darkTheme ? props.theme.borderColor : 'var(--greyBorderColor)')};
  border-radius: 4px;
  padding-left: 10px;
  -webkit-appearance: none;
  -moz-appearance: none;
  @media (min-width: 768px) {
    padding-left: 12px;
  }
  :hover {
    outline: none;
    border: ${(props) =>
      props.disabled && props.darkTheme
        ? `1px solid ${props.theme.borderColor}`
        : props.disabled && !props.darkTheme
        ? '1px solid var(--greyBorderColor)'
        : '1px solid var(--brandColor)'};
  }
  :focus {
    outline: none;
    border: ${(props) =>
      props.disabled && props.darkTheme
        ? `1px solid ${props.theme.borderColor}`
        : props.disabled && !props.darkTheme
        ? '1px solid var(--greyBorderColor)'
        : '2px solid var(--brandColor)'};
  }
`;

const CountryDropdown = ({ style, setPhoneCode, phoneCode, from, darkTheme, isFromModal }) => (
  <Dropdown style={style} onChange={setPhoneCode} value={phoneCode} from={from} darkTheme={darkTheme} isFromModal={isFromModal}>
    {country.map(({ name, dial_code, code }) => (
      <option key={code} value={dial_code}>{`${name} ${dial_code}`}</option>
    ))}
  </Dropdown>
);

export default CountryDropdown;
